onResetStore